<template>
  <el-card class="container" body-style="width: 100%;padding: 0;">
    <div class="header" v-if="!!title">
      {{ title }}
    </div>
    <div class="content">
      <div class="row-item" v-for="row in rows" :key="row.key">
        <div class="row-title">{{ row.label }}:</div>
        <div class="row-content">{{ row.value }}</div>
      </div>
      <div class="btns">
        <slot></slot>
      </div>
    </div>
  </el-card>
</template>
<script>
/**
/**
 * @typedef {Object} Item
 * @property {string } label
 * @property {string | number} value
 */

export default {
  name: "MobileCard",
  props: {
    /** @type Array<Item> */
    rows: Array,
    title: String,
    id: [String, Number],
  },
  methods: {
    toDetail() {
      this.$emit("to-detail");
    },
    edit() {
      this.$emit("edit");
    },
    deletePlan() {
      this.$emit("delete-plan");
    },
    viewRules() {
      this.$emit("to-rule-page");
    },
  },
};
</script>
<style scoped lang="less">
.container {
  width: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  box-sizing: border-box;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: large;
  padding-bottom: 0.3rem;
}

.content {
  padding-left: 0.5rem;
}

.row-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-title {
  font-size: small;
  width: 50%;

  font-weight: bold;
}

.row-content {
  width: 50%;
  text-indent: 1rem;
  font-size: small;
}

.btns {
  padding-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
